import React from 'react';
import insightsBg from '../../../assets/site/bg-insights.jpg';
import FeatureCard from '../../site/components/FeatureCard';
import Section from '../../site/components/Section';
import SectionHead from '../../site/components/SectionHead';
import { insights } from '../../site/data/content';
import ui from '../../site/styles/primitives.module.css';

const Insights = () => (
  <Section id="insights" overlay="soft" background={insightsBg} backgroundPosition="center">
    <div className={ui.wrap}>
      <SectionHead
        eyebrow="Investment insights"
        title="Perspective for"
        highlight="smarter investing"
        lede="Market notes and guidance from the DS360 team."
      />
      <div className={ui.grid3}>
        {insights.map((article, index) => (
          <FeatureCard
            key={article.title}
            image={article.image}
            tag={article.tag}
            title={article.title}
            text={article.text}
            href={article.href}
            linkLabel="Read article"
            external
            surface={index % 2 === 0 ? 'glass' : 'matte'}
          />
        ))}
      </div>
    </div>
  </Section>
);

export default Insights;
